module.exports = __webpack_public_path__ + "static/media/logo177.bdb4dd87.png";